import { Injectable } from '@angular/core';
import { createFrom, EventService } from '@spartacus/core';
import { Order } from '@spartacus/order/root';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { GtmGgOrderPlacedEvent } from './gtm-gg-order-placed-event';
import { CheckoutFacade, OrderPlacedEvent } from '../../../../spartacus/features/legacy-checkout/root';

@Injectable({
  providedIn: 'root',
})
export class GtmGgOrderPlacedEventBuilder {
  constructor(
    private eventService: EventService,
    private orderService: CheckoutFacade
  ) {
    const gtmGgOrderPlacedEventSource = this.eventService.get(OrderPlacedEvent).pipe(
      switchMap(() =>
        this.orderService.getOrderDetails().pipe(
          filter((order: Order | undefined): order is Order => !!order && !!order.entries),
          take(1),
          map((orderDetails) =>
            createFrom(GtmGgOrderPlacedEvent, {
              event: 'transaction',
              transactionPostalCode: orderDetails.deliveryAddress?.postalCode
                ? orderDetails.deliveryAddress?.postalCode
                : '',
              transactionCountryName: orderDetails.deliveryAddress?.country?.name
                ? orderDetails.deliveryAddress?.country?.name
                : '',
              ecommerce: {
                purchase: {
                  actionField: {
                    id: orderDetails.code ? orderDetails.code : '',
                    affiliation: orderDetails.site ? orderDetails.site : '',
                    revenue: orderDetails.totalPrice?.value ? orderDetails.totalPrice?.value.toString() : '',
                    tax: orderDetails.totalTax?.value ? orderDetails.totalTax?.value.toString() : '',
                    shipping: orderDetails.deliveryCost?.value ? orderDetails.deliveryCost?.value.toString() : '',
                    coupon: this.getAppliedVouchersFromOrder(orderDetails),
                  },
                  products: this.getProductsFromOrder(orderDetails),
                },
              },
            })
          )
        )
      )
    );

    eventService.register(GtmGgOrderPlacedEvent, gtmGgOrderPlacedEventSource);
  }

  getProductsFromOrder(orderDetails: Order) {
    const products: {
      id?: string;
      name?: string;
      category?: string;
      price?: string;
      brand?: string;
      variant?: string;
      quantity?: number;
    }[] = [];

    orderDetails.entries?.forEach((entry) => {
      const product = {
        id: entry.product?.code ? entry.product?.code : '',
        name: entry.product?.name ? entry.product?.name : '',
        category: entry.product?.mainCategoryName ? entry.product?.mainCategoryName : '',
        price: entry.basePrice?.value ? entry.basePrice?.value.toString() : '',
        brand: entry.product?.manufacturer ? entry.product?.manufacturer : '',
        variant: entry.product?.variantType ? entry.product?.variantType : '',
        quantity: entry.quantity,
      };

      products.push(product);
    });

    return products;
  }

  getAppliedVouchersFromOrder(orderDetails: Order) {
    let appliedVouchers = '';

    orderDetails.appliedVouchers?.forEach((voucher) => {
      appliedVouchers = appliedVouchers + ',' + voucher;
    });

    return appliedVouchers;
  }
}
